import { makeStyles } from "@fluentui/react-components";
import { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { $white } from "../../cssjs/colors";
import { FlightCard } from "../shared/components/airport-cards/FlightCard";
import { FlightTabs } from "../shared/components/airport-cards/flights/FlightTabs";
import { FlightDetails } from "../shared/components/airport-cards/flights/tab-content/FlightDetails";

export const OverviewCarousel: React.FC<any> = (props) => {
  const classes = useClasses();

  const { selectedFlight, setSelectedFlight } = useContext(LayoutContext);
  const showFlightDetails = selectedFlight?.flightDocID !== undefined;

  return (
    <div className={classes.container}>
      {showFlightDetails && (
        <FlightDetails
          setSelectedFlight={setSelectedFlight}
          selectedFlight={selectedFlight}
        />
      )}
      <FlightCard
        key="carouselFlightCard"
        isCarousel={true}
        showFlightDetails={showFlightDetails}
        airportCode={props.airportCode}
      />
      <FlightTabs
        showFlightDetails={showFlightDetails}
        key="carouselFlightDetailsCard"
      />
    </div>
  );
};

const useClasses = makeStyles({
  container: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr",
    minHeight: "640px",
    background: $white,
    height: "73vh",
    "@media (max-width: 768px)": {
      minHeight: "480px",
    },
  },
});
